import { commonWidthValues } from 'common/constants/commonWidth'
import { ContentWidthEnum } from 'common/types/styleTypes'

export const contentWidthValues = {
  [ContentWidthEnum.xs]: commonWidthValues.extraSmall,
  [ContentWidthEnum.s]: commonWidthValues.small,
  [ContentWidthEnum.m]: commonWidthValues.medium,
  [ContentWidthEnum.l]: commonWidthValues.wide,
  [ContentWidthEnum.xl]: commonWidthValues.fullPage,
}
